import React from 'react'
import styled from 'styled-components'
import Colors from '../assets/styles/Colors'
import { Container } from '../assets/styles/GlobalStyle'
import Responsive from '../assets/config/Responsive'
import PlayStores from './PlayStores'
import api from '../api'
import Loader from './Loader'
import { useAppSelector } from '../store'
import { AppState } from '../store/appSlice'
//
//
const AppDownloadSection = () => {
  //
  const { lang } = useAppSelector((root: { app: AppState }) => root.app)
  //
  const { data: mainpageTextList, isLoading: isMainPageTextLoading } = api.useGetMainPageTextListQuery(undefined)
  //
  return isMainPageTextLoading ? (
    <Loader horizontal={true} />
  ) : (
    <DownloadSection>
      <Container>
        <ServiceHead>
          <h1>
            {mainpageTextList?.find((item) => item.slug === 'main-page-fourth-block')?.translations?.[lang]?.title}
          </h1>
          <p>
            {mainpageTextList?.find((item) => item.slug === 'main-page-fourth-block')?.translations?.[lang]?.excerpt}
          </p>
        </ServiceHead>
        <PlayStores />
      </Container>
    </DownloadSection>
  )
}
//
const ServiceHead = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-bottom: 65px;
  position: sticky;
  z-index: 1;
  /* TItle */
  h1 {
    /* font-size: 36px; */
    font-size: 20px;
    color: ${Colors.Black};
    margin-bottom: 35px;
    text-align: center;
  }
  /* description */
  p {
    font-size: 18px;
    color: ${Colors.SilverChalice};
    margin-bottom: 35px;
    width: 50%;
    text-align: center;
  }
  ${Responsive.mobile} {
    margin-bottom: 30px;
    /* TItle */
    h1 {
      font-size: 18px;
      margin-bottom: 16px;
    }
    /* description */
    p {
      font-size: 12px;
      margin-bottom: 0px;
      width: 100%;
    }
  }
`
const DownloadSection = styled.section`
  position: sticky;
  padding-top: 85px;
  padding-bottom: 85px;
  position: relative;
  overflow-y: hidden;
  user-select: none;
  pointer-events: none;
  ${Responsive.mobile} {
    padding-top: 30px;
    padding-bottom: 40px;
  }
`
//
export default AppDownloadSection
